module.exports = __webpack_public_path__ + "officialStatic/img/logo4.4fb82c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/logo4.png
// module id = cRtg
// module chunks = 0